import { IEnvVars } from "shared/utils";

const DEV_ENV_VARS: IEnvVars = {
  CLIENT_ID: "67154-ASDS-WebApp",
  API_ENDPOINT:
    "https://asds-apm-web-exp-api-orwtmpyt-dev-dskmulis.apps.dev.aks.honaero.com/apm",
  FEL_ENDPOINT:
    "https://qasds.honeywellaerospace.com/servicerequest/elt/swlib/servicehome.do",
  ASDS_ENDPOINT: "https://dasds.honeywellaerospace.com:8980/ads/broadcast/message",
};

export default DEV_ENV_VARS;
